// Winrate→tailwind-tone mapping shared across surfaces that visualize
// gauntlet/playtest results. >55% reads as favorable (accent), <45% as
// unfavorable (danger). Even matchups stay neutral (text-fg-muted)
// rather than highlighting either side.

export function winrateTone(pct: number | null): string {
  if (pct === null) return "text-fg-subtle";
  if (pct > 55) return "text-accent";
  if (pct < 45) return "text-danger";
  return "text-fg-muted";
}
